// Libraries
import _ from 'lodash';
import React, {forwardRef} from 'react';

// Supermove
import {Form, Space, Styled} from '@supermove/components';
import {DocumentNode, gql} from '@supermove/graphql';
import {DocumentItemInputChargePaymentType, DocumentModel} from '@supermove/models';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';
import {DocumentV2ChargeClientCardHandle} from '@shared/modules/Document/components/DocumentV2ChargeClientCreditCard';
import DocumentV2ChargePaymentInputEdit from '@shared/modules/Document/components/DocumentV2ChargePaymentInputEdit';
import DocumentV2ChargePaymentInputView from '@shared/modules/Document/components/DocumentV2ChargePaymentInputView';

const Row = Styled.View`
  flex-direction: row;
`;

type DocumentV2ChargePaymentInputProps = {
  input: DocumentItemInputChargePaymentType['input'];
  form: Form;
  field: string;
  isEditable: boolean;
  isRequired: boolean;
  document: DocumentModel;
};

type DocumentV2ChargePaymentInputComponent = React.ForwardRefExoticComponent<
  DocumentV2ChargePaymentInputProps & React.RefAttributes<DocumentV2ChargeClientCardHandle>
> & {
  fragment: DocumentNode;
  query: DocumentNode;
};

const DocumentV2ChargePaymentInput = forwardRef<
  DocumentV2ChargeClientCardHandle,
  DocumentV2ChargePaymentInputProps
>(({input, form, field, isEditable, isRequired, document}, ref) => {
  const requiredError = _.get(form?.errors, `${field}.input.value.paymentId`, undefined);

  return document ? (
    <React.Fragment>
      <DocumentV2ChargePaymentInputEdit
        ref={ref}
        input={input}
        form={form}
        field={field}
        isEditable={isEditable}
        isRequired={isRequired}
        document={document}
      />
      {requiredError && (
        <React.Fragment>
          <Space height={2} />
          <Row style={{justifyContent: 'flex-end'}}>
            <FieldInput.CaptionText hasErrors size={FieldInput.SIZE.MEDIUM}>
              {requiredError}
            </FieldInput.CaptionText>
          </Row>
        </React.Fragment>
      )}
    </React.Fragment>
  ) : (
    <DocumentV2ChargePaymentInputView input={input} />
  );
}) as DocumentV2ChargePaymentInputComponent;

DocumentV2ChargePaymentInput.fragment = gql`
  ${DocumentV2ChargePaymentInputEdit.fragment}

  fragment DocumentV2ChargePaymentInput_Document on Document {
    id
    ...DocumentV2ChargePaymentInputEdit_Document
  }
`;

export default DocumentV2ChargePaymentInput;
